import { studentEmailVerificationRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Student];

const studentEmailVerificationRouteMetadata: IRouteMetadataObj<
  typeof studentEmailVerificationRoutesObj
> = {
  view: {
    title: "emailVerification.title",
    description: "emailVerification.description",
    lazy: () =>
      import("@pages/studentPages/editProfile/emailStepTwoVerification/page"),
    mode: "index",
    type: "inner",
    icon: "LayoutGridLine",
    breadcrumbs: [],
    permission,
  },
};

export const studentEmailVerificationRoutes = createRoute<
  typeof studentEmailVerificationRoutesObj
>(studentEmailVerificationRoutesObj, studentEmailVerificationRouteMetadata);
